enum ReactQueryKeys {
  GET_ACCOUNT_INFORMATION = 'getAccountInformation',
  GET_APPLICATION_STATUS = 'getApplicationStatus',
  HAS_PAYROLL_PRODUCT = 'hasPayrollProduct',
}

export { ReactQueryKeys };
